import Container from "../../../components/Container";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { IRecipeRecord } from "../../../lib/types";
import pb from "../../../lib/pocketbase";
import { Link, useParams } from "react-router-dom";
import { config } from "../../../config";
import Checkbox from "../../../components/form/checkbox";
import { RecipeTags } from "../../../lib/consts";
import BackButton from "../../../components/form/BackButton";
import Button from "../../../components/form/button";
import Markdown, { MarkdownStyle } from "../../../components/markdown/Markdown";
import { useToast } from "../../../components/ui/use-toast";
interface IIngredient {
    ingredient: string;
}

export default function Recipe() {
    const id = useParams().id;
    const [loading, setLoading] = useState(true);
    const [recipe, setRecipe] = useState<IRecipeRecord>();
    const { toast } = useToast();

    function copyUrl() {
        navigator.clipboard?.writeText(`${config.base}/recipe/${recipe?.slug}/${id}`);
        toast({
            title: "🤩 Successfully copied url!",
            description: "You have successfully copied the url of this recipe."
        });
    }

    async function load() {
        if (!id) return;
        const record: IRecipeRecord = await pb.collection("recipe").getOne(id, {
            expand: "ingredients"
        });
        console.log(record);

        setRecipe(record);
        setLoading(false);
    }

    useEffect(() => {
        load();
    }, []);

    const image = config.pocketbase + "/api/files/" + recipe?.collectionId + "/" + recipe?.id + "/" + recipe?.image;
    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Cookbook</title>
            </Helmet>
            <div className="relative mb-12 md:mb-0">
                <BackButton variant={"light"} size={"small"} className="absolute left-2 top-2" />
                <img src={image} alt={recipe?.title} className="hidden h-64 w-full object-cover md:block" />
                <Link to="edit" className="absolute right-2 top-2">
                    <Button variant={"light"} size={"small"}>
                        Edit
                    </Button>
                </Link>
            </div>

            <Container className="my-8 @container md:my-8 lg:my-16">
                <MarkdownStyle>
                    <div className="flex items-center gap-2">
                        {recipe?.tags.map((tag) => {
                            return <div className="w-fit rounded bg-slate-200 px-2 py-1 text-sm dark:bg-slate-700">{RecipeTags[tag]}</div>;
                        })}
                    </div>
                    <div className="mt-4 flex items-center gap-4">
                        <h1 className="m-0">{recipe?.title}</h1>
                        {recipe?.public && (
                            <Button onClick={copyUrl} variant={"ghost"} size={"ghost"}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15" />
                                </svg>
                            </Button>
                        )}
                    </div>
                    {recipe?.duration && <div className="italic text-slate-400 dark:text-slate-500">Duration: {recipe.duration}</div>}
                    <div>Servings: {recipe?.servings}</div>
                    <div>
                        <h2>Ingredients:</h2>
                        <div className="mt-4 flex flex-col gap-2">
                            {recipe?.expand.ingredients?.map((ingredient: IIngredient) => {
                                return <Checkbox checked={false} onClick={() => {}} label={ingredient.ingredient} />;
                            })}
                        </div>
                    </div>
                    <div className="mt-8">{recipe?.recipe && <Markdown>{recipe.recipe}</Markdown>}</div>
                </MarkdownStyle>
            </Container>
        </>
    );
}
